import React, { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { Link } from "react-router-dom";
import { all_routes } from "../../../../feature-module/router/all_routes";
import { useDispatch, useSelector } from "react-redux";
import { Option } from "../../../../feature-module/pages/license-registration-form/CommonSelect";
import { setHomeLanguage } from "../../../data/redux/authSlice";
import CommonSelect from "../../commonSelect";
import Select from "react-select";
interface NavbarProps {
  atMore?: boolean;
  hlanguage?: any;
  setNavbarLanguage?: (lang: string) => void;
}
const Navbar = (
  { atMore, setNavbarLanguage, hlanguage }: NavbarProps
) => {
  const routes = all_routes;
  const [searchParams] = useSearchParams();
  const selectedRole = searchParams.get("role");
  const dispatch = useDispatch();
  const Location = useLocation();
  const navigate = useNavigate();
  // const hlanguage = useSelector((state:any)=>state.auth.homeLanguage);
  const [subOpen, setSubopen] = useState<any>("");
  const [subsidebar, setSubsidebar] = useState("");
  const [isRoleSelected, setIsRoleSelected] = useState(false);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const ssoid = queryParams.get('SSOId');
  const loginRole = queryParams.get("role");

  // const setlang = hlanguage.home === "Home" ? "english" : "gujarati";

  // const [selectedLanguage, setSelectedLanguage] = useState<{
  //   label: string;
  //   value: string;
  // }>({
  //   label: setlang === "english" ? "English" : "ગુજરાતી",
  //   value: setlang,
  // });

  const [selectedLanguage, setSelectedLanguage] = useState<Option>(
    { label: "English", value: "homeEn" }
  );

  useEffect(() => {
    if (hlanguage?.home === "Home") {
      setSelectedLanguage({ label: "English", value: "homeEn" });
    } else {
      setSelectedLanguage({ label: "ગુજરાતી", value: "homeGu" });
    }
  }, [hlanguage?.home]);

  const [isFullscreen, setIsFullscreen] = useState(false);
  const toggleFullscreen = () => {
    if (!isFullscreen) {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen().catch((err) => {});
        setIsFullscreen(true);
      }
    } else {
      if (document.exitFullscreen) {
        if (document.fullscreenElement) {
          document.exitFullscreen().catch((err) => {});
        }
        setIsFullscreen(false);
      }
    }
  };

  const handleSSOLogin = (role)=>{
    const returnurl = `https://gil.thesaicomputers.com/ssoLogin/${role}`;
    const accesskey = "b6e01c1d689344ad9b412200fb365cc3";
    const combined = `${returnurl}||${accesskey}`;
    const base64Encoded = btoa(combined)
    window.location.href = `https://gujaratsso.gujarat.gov.in/?redirectUrl=${base64Encoded}`;
  }

  const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }
};

  return (
    <>
      <style>{`
        .navbar {
          background-color: #004e15ff !important; 
          padding: 0;
        }

        .nav-link {
          color: white !important;
          padding: 12px 20px;
          font-weight: 600;
          display: flex;
          align-items: center;
          height: 100%;
          transition: background-color 0.3s ease;
          font-size: 0.95rem;
        }

        @media (min-width: 992px) {
          .nav-link {
            padding: 15px 25px;
          }
        }

        @media (min-width: 1200px) {
          .nav-link {
            padding: 15px 35px;
          }
        }
        
        .navbar-nav .nav-item .nav-link:hover{
          background-color: rgb(0, 111, 30) !important; 
        }

        .navbar-dark .navbar-nav .nav-link {
          background: transparent !important;
        }

        .input-group {
          border-radius: 8px;
          overflow: hidden;
        }

        .form-control {
          border: none;
          border-radius: 8px 0 0 8px;
        }

        .btn-light {
          border: none;
          background-color: white !important;
        }

        .btn-light:hover {
          background-color: #f1f1f1 !important;
        }

        .fa-search {
          color: #004e15ff;
        }

        @media (max-width: 991px) {
          .navbar-collapse {
            background-color: #004e15ff;
            padding: 1rem;
            margin-top: 0.5rem;
            border-radius: 8px;
          }

          .nav-link {
            border-bottom: 1px solid rgba(255,255,255,0.1);
          }

          .nav-link:last-child {
            border-bottom: none;
          }
        }
      `}</style>

      <nav className="navbar navbar-expand-lg navbar-dark sticky-top">
        <div className="px-3 px-sm-3 px-lg-5 mx-0 mx-lg-3 py-1 w-100">
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#mainNav"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="mainNav">
            <ul className="navbar-nav me-auto mb-3 mb-lg-0 w-100 w-lg-auto">
              <li className="nav-item">
                <NavLink to="/" end className="nav-link" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
                  {hlanguage?.home}
                </NavLink>
              </li>

              <li className="nav-item">
                <button
                  type="button"
                  className="nav-link w-100 text-start" 
                  onClick={() => {
                    const loginRole = "Trader"
                    handleSSOLogin(loginRole);
                  }}
                  style={{
                    background: "inherit",
                    border: "none",
                  }}
                >
                  {hlanguage?.tra_login}
                </button>
              </li>

              <li className="nav-item">
                <button
                  type="button"
                  className="nav-link w-100 text-start" 
                  onClick={() => {
                    const loginRole = "Panel_Engineer"
                    handleSSOLogin(loginRole);
                  }}
                  style={{
                    background: "inherit",
                    border: "none",
                  }}
                >
                  {hlanguage?.pa_login}
                </button>
              </li>

              <li className="nav-item">
                <button
                  type="button"
                  className="nav-link w-100 text-start" 
                  onClick={() => {
                    const loginRole = "General_Commission_Agent"
                    handleSSOLogin(loginRole);
                  }}
                  style={{
                    background: "inherit",
                    border: "none",
                  }}
                >
                  {hlanguage?.gc_login}
                </button>
              </li>

              <li className="nav-item">
                 {atMore ? (
                   <NavLink to="/" className="nav-link">
                     {hlanguage?.gallery}
                   </NavLink>
                 ) : (
                   <Link to="#" onClick={() => scrollTo("gallery")} className="nav-link">
                     {hlanguage?.gallery}
                   </Link>
                 )}
              </li>


              <li className="nav-item">
                {atMore ? (
                  <NavLink to="/" className="nav-link">
                    {hlanguage?.about}
                  </NavLink>
                ) : (
                  <Link to="#" onClick={() => scrollTo("about-us")} className="nav-link">
                    {hlanguage?.about}
                  </Link>
                )}
              </li>

            </ul>

            <div className="d-flex flex-column flex-lg-row align-items-start align-items-lg-center justify-content-start justify-content-lg-center gap-3 mt-3 mt-lg-0 pb-3 pb-lg-0">
              <div className="d-flex flex-row align-items-center gap-2 w-100 w-lg-auto">
                <h5 className="text-white mb-0 text-nowrap">{hlanguage?.lang}:</h5>
                <div className="flex-grow-1 flex-lg-grow-0" style={{minWidth: "150px"}}>
                 <Select
                    options={[
                      { label: "English", value: "homeEn" },
                      { label: "ગુજરાતી", value: "homeGu" },
                    ]}
                    value={selectedLanguage} 
                    defaultValue={selectedLanguage}
                    isSearchable={false}   
                    // onChange={(option) => {
                    //   if (option) {
                    //     setSelectedLanguage(option);
                    //     dispatch(setHomeLanguage(option.value));
                    //   }
                    // }}
                    onChange={(option) => {
                      if (option) {
                        setSelectedLanguage(option);
                        setNavbarLanguage(option.value);
                      }}}

                    styles={{
                      control: (base, state) => ({
                        ...base,
                        backgroundColor: "transparent",       // no fill
                        border: "2px solid white",             // white outline
                        borderRadius: "6px",
                        boxShadow: "none",
                        minHeight: "42px",
                        "&:hover": {
                          borderColor: "white",
                        },
                      }),

                      singleValue: (base) => ({
                        ...base,
                        color: "white",                        // white text
                        fontWeight: "600",
                      }),
                      option: (base, state) => ({
                        ...base,
                        backgroundColor: state.isSelected
                          ? "#004e15ff"
                          : state.isFocused
                          ? "#e6f4ea"
                          : "white",
                        color: state.isSelected ? "white" : "#000",
                      }),
                    }}
                  />
                </div>
              </div>

              <div className="w-100 w-lg-auto">
                <div className="dropdown">
                  <button
                    className="btn d-flex align-items-center justify-content-center"
                    type="button"
                    id="loginMenuButton"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    style={{
                      width: 60,
                      height: 50,
                      padding: 0,
                      backgroundColor: "transparent",
                    }}
                  >
                    <div className="d-flex gap-1 flex-column">
                      <i
                        className="fa-solid fa-user"
                        style={{ color: "white" }}
                      ></i>
                      <p className="small text-white mb-0">{hlanguage?.profiles}</p>
                    </div>
                  </button>

                  <ul
                    className="dropdown-menu dropdown-menu-end p-2"
                    aria-labelledby="loginMenuButton"
                    style={{ minWidth: 220, borderRadius: 8 }}
                  >
                    {[
                      { value: "Trader_Login", label: hlanguage?.tra_login },
                      { value: "GCA_Login", label: hlanguage?.gc_login },
                      // { value: "Sponsor_Login", label:hlanguage?.spon_login },
                      {
                        value: "Panel_Engineer_Login",
                        label: hlanguage?.pa_login,
                      },
                      {
                        value: "District_Registrar_Login",
                        label: hlanguage?.dr_login
                      },
                      { value: "APMC_Login", label: hlanguage?.ap_login },
                      {
                        value: "Head_officer_Login",
                        label: hlanguage?.ho_login
                      },
                    ].map((item) => (
                      <li key={item.value}>
                        {["Trader_Login", "Panel_Engineer_Login","GCA_Login"].includes(item.value) ? (
                          <button
                            type="button"
                            className="dropdown-item"
                            onClick={() => {
                              const loginRole =
                                item.value === "Trader_Login"
                                  ? "Trader"
                                  : item.value === "Panel_Engineer_Login"
                                  ? "Panel_Engineer"
                                  : item.value === "GCA_Login"
                                  ? "General_Commission_Agent"
                                  : "";
                              handleSSOLogin(loginRole);
                            }}
                            style={{
                              background: "inherit",
                              border: "none",
                            }}
                          >
                            <i className="fas fa-sign-in-alt mx-1"></i> 
                            {item.label}
                          </button>
                        ) : (
                          <Link
                            className="dropdown-item"
                            to={`${all_routes.login2}?role=${item.value}`}
                          >
                            <i className="fas fa-sign-in-alt mx-1"></i> {item.label}
                          </Link>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;